module.exports = __webpack_public_path__ + "static/media/ic_close.6ce78d14.svg";